import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import "./component.css";
import { IoBagCheck, IoSync } from "react-icons/io5";

const ListOrderAktif = () => {
  const { user } = useSelector((state) => state.auth);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `https://c-greenproject.org:8000/orderberlangsung`,
        {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        }
      );
      setProducts(response.data);
    } catch (error) {
      setMsg(error.response ? error.response.data.msg : "Error fetching data");
    }
  };

  return (
    <div>
      <h2 className="title">
        <strong>Order Berlangsung</strong>
      </h2>
      <div className="detail-table-container">
        <table className="table is-striped is-fullwidth detail-table">
          <thead>
            <tr className="text-center">
              <th>No</th>
              <th>Nama Petani</th>
              <th>Varietas</th>
              <th>Status Order</th>
              <th>Tanggal Panen</th>
              <th>Estimasi Berat (kg)</th>
              <th>Harga</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="text-center">
            {products.map((product, index) => (
              <React.Fragment key={product.uuid}>
                <tr>
                  <td>{index + 1}</td>
                  <td>{product.user?.name || "No Name"}</td>
                  <td>{product.varietasSingkong}</td>
                  <td>{product.statusOrder}</td>
                  <td>{product.tanggalPemanenan}</td>
                  <td>{product.estimasiBerat}</td>
                  <td>Rp {product.estimasiHarga}</td>
                  <td>
                    {user.role === "petani" && (
                      <button
                        className="btn btn-primary button-tabel"
                        onClick={() =>
                          navigate(`/products/update/${product.uuid}`)
                        }
                      >
                        <IoSync /> Update
                      </button>
                    )}

                    {user.role === "pabrik" && (
                      <button
                        className="btn btn-primary button-tabel"
                        onClick={() =>
                          navigate(`/pabrik/transaksi/${product.uuid}`)
                        }
                      >
                        <IoSync /> Update
                      </button>
                    )}

                    {user.role === "logistik" &&
                      product.statusOrder === "Menunggu waktu panen" && (
                        <button
                          className="btn btn-success mt-2 button-tabel"
                          onClick={() =>
                            navigate(`/logistik/transaksi/${product.uuid}`)
                          }
                        >
                          <IoBagCheck /> Diantar
                        </button>
                      )}

                    {user.role === "perusahaan" && (
                      <button
                        className="btn btn-success button-tabel"
                        onClick={() =>
                          navigate(`/products/selesai/${product.uuid}`)
                        }
                      >
                        <IoBagCheck /> Selesai
                      </button>
                    )}
                  </td>
                </tr>
                <tr className="detail-row">
                  <td colSpan="9">
                    <button
                      className="btn btn-link btn-sm detail-button"
                      onClick={() =>
                        navigate(`/products/detail/${product.uuid}`)
                      }
                    >
                      Lihat Detail Order
                    </button>
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
        {msg && <p className="notification is-danger">{msg}</p>}
        {loading && <p className="notification is-info">Loading...</p>}
      </div>
    </div>
  );
};

export default ListOrderAktif;
